module.exports = __webpack_public_path__ + "img/symbol_9.b45d0419.png";